import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWestfieldDirectinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		stroke: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("polyline", {
				strokeWidth: 2,
				points: "16 20 15 17 26 12 33 24"
			}),
			/* @__PURE__ */ _jsx("polyline", {
				strokeWidth: 2,
				points: "23 29.5 20.5 31 19.5 28.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeWidth: 2,
				d: "M18.5 17.5L16 12C15.3512381 10.5019048 15.9548571 8.66857143 17.5 8 19.0451429 7.33142857 20.8524762 8.00190476 21.5 9.5L24 15M60 13L54 13 48 29 31 29C28 29 26 31 26 34L26 49 38 49M50.9987903 57C55.9681452 57 59.9975806 52.9705645 59.9975806 48.0012097 59.9975806 43.0294355 55.9681452 39 50.9987903 39 46.0282258 39 42 43.0294355 42 48.0012097 42 52.9705645 46.0282258 57 50.9987903 57z"
			}),
			/* @__PURE__ */ _jsx("polyline", {
				strokeWidth: 2,
				points: "48 29 41 8 36 9"
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 11,
				x2: 6,
				y1: 17,
				y2: 17,
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 12,
				x2: 9,
				y1: 20,
				y2: 20,
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("polygon", {
				strokeWidth: 2,
				points: "15 33.5 17.5 23 7 27 9 29 3.5 35 7.5 38.5 13 32"
			})
		]
	})
});
export default SvgWestfieldDirectinline;
